import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/hooks/translation';
import Config from '@app/dev/config/main';
import CountDownComponent from '../countDownClock';

const TerminalError = ({ closePopup, data }) => {
  const t = useTranslation();

  const errorMessage = typeof data === 'object' ? data.errorText || data.error : data;
  const customError = t(`terminal_error_${errorMessage}`);
  const isCustomErrorExists = customError !== `terminal_error_${typeof data === 'object' ? data.errorText || data.error : data}`;

  return (
    <div className="popup-content popup-small lockterminal">
      <i
        onClick={closePopup}
        className="global-icon icon-Close close-popup"
      />
      <div className="popup-message error" />
      <h3 className="popup-title">{isCustomErrorExists && Config.main.showCustomLockScreenMessages ? customError : t(errorMessage)}</h3>
      <div className="popup-timer">
        <CountDownComponent second={60} timerColor="#f73535" />
      </div>
    </div>
  );
};

TerminalError.propTypes = {
  data: PropTypes.any,
  closePopup: PropTypes.func,
};

export default TerminalError;
